import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  makeGetEventAway,
  makeGetEventHome,
  makeGetEventScoreAway,
  makeGetEventScoreHome,
  makeGetEventStartTime,
  makeGetEventTimeOrPeriodAbbr,
  makeIsEventInPlay
} from '../../../modules/events/selectors';
import { LIVE_SCORES } from '../../../routes/paths';
import { getEventsDay } from '../selectors';

export const EventTile = ({
  eventId,
  eventsDay,
  eventHome,
  eventAway,
  eventStartTime,
  isInPlay,
  scoreHome,
  scoreAway,
  eventTimeOrPeriod
}) => {
  const scoreClasses = classnames('live-scores-event-tile__box',
    {
      'live-scores-event-tile__box--inplay': isInPlay,
      'live-scores-event-tile__box--score': !isInPlay
    }
  );
  const showScore = isInPlay || (scoreHome !== '' && scoreAway !== '');
  const defaultScore = isInPlay ? 'LIVE' : '';
  const score = (scoreHome !== '' && scoreAway !== '')
    ? (`${scoreHome} - ${scoreAway}`)
    : defaultScore;
  return (
    <div className="live-scores-event-tile">
      <div className="live-scores-event-tile__time">
        {eventTimeOrPeriod}
      </div>
      <div className="live-scores-event-tile__home">
        {eventHome}
      </div>
      {showScore ? (
        <div className={scoreClasses}>
          <Link
            to={`${LIVE_SCORES}/${eventsDay}/${eventId}`}
            className="live-scores-event-tile__box-link"
          >
            {score}
          </Link>
        </div>
      ) : (
        <div className="live-scores-event-tile__box live-scores-event-tile__box--time">
          <Link
            to={`${LIVE_SCORES}/${eventsDay}/${eventId}`}
            className="live-scores-event-tile__box-link"
          >
            {eventStartTime}
          </Link>
        </div>
      )}
      <div className="live-scores-event-tile__away">
        {eventAway}
      </div>
    </div>
  );
};

EventTile.propTypes = {
  eventId: PropTypes.string.isRequired,
  eventsDay: PropTypes.number.isRequired,
  eventHome: PropTypes.string.isRequired,
  eventAway: PropTypes.string.isRequired,
  eventStartTime: PropTypes.string.isRequired,
  isInPlay: PropTypes.bool,
  scoreHome: PropTypes.string,
  scoreAway: PropTypes.string,
  eventTimeOrPeriod: PropTypes.string
};

const makeMapStateToProps = (initialState, initialProps) => {
  const getEventStartTime = makeGetEventStartTime();
  const getEventHome = makeGetEventHome();
  const getEventAway = makeGetEventAway();
  const isEventInPlay = makeIsEventInPlay();
  const getEventScoreHome = makeGetEventScoreHome();
  const getEventScoreAway = makeGetEventScoreAway();
  const getEventTimeOrPeriodAbbr = makeGetEventTimeOrPeriodAbbr();
  return (state) => ({
    eventId: initialProps.eventId,
    eventsDay: getEventsDay(state),
    eventHome: getEventHome(state, initialProps),
    eventAway: getEventAway(state, initialProps),
    eventStartTime: getEventStartTime(state, initialProps),
    isInPlay: isEventInPlay(state, initialProps),
    scoreHome: getEventScoreHome(state, initialProps),
    scoreAway: getEventScoreAway(state, initialProps),
    eventTimeOrPeriod: getEventTimeOrPeriodAbbr(state, initialProps)
  });
};

export default connect(makeMapStateToProps)(EventTile);
